import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DashboardLayout } from '../../components/atoms';
import { styleGuideSelector } from '../../store/globalSlice/styleSlice';
import { useAuth } from '../../store/auth';
import { getUserRoleLabel } from '../../utils/userRoleHelper';
import { FiHome, FiUser, FiFileText, FiSettings } from 'react-icons/fi';

const DashboardAsideBar = lazy(() => import('../../components/DashboardTemplate/DashboardAsideBar'));
const DashboardHeader = lazy(() => import('../../components/DashboardTemplate/DashboardHeader'));

const DashboardDirector: React.FC = () => {
  const { t } = useTranslation();
  const { colors } = useSelector(styleGuideSelector);
  const { user } = useAuth();
  
  // Identifica se é diretor ou acionista usando o helper
  const roleLabel = getUserRoleLabel(user, t);

  const dashboardItems = {
    initial: [
      {
        label: t('titles.ttlHome') || 'Home',
        icon: <FiHome color={colors.primary} size={24} />,
        href: '/dashboard'
      }
    ],
    company: [
      {
        label: t('labels.lblMyProfile') || 'My Profile',
        icon: <FiUser color={colors.primary} size={24} />,
        href: '/dashboard/profile'
      },
      {
        label: t('labels.lblMyDocuments') || 'My Documents',
        icon: <FiFileText color={colors.primary} size={24} />,
        href: '/dashboard/documents'
      }
    ],
    config: [
      {
        label: t('labels.lblPrefereces') || 'Preferences',
        icon: <FiSettings color={colors.primary} size={24} />,
        href: '/dashboard/preferences'
      }
    ]
  };

  return (
    <DashboardLayout
      headerComponent={<DashboardHeader />}
      sidebarComponent={
        <DashboardAsideBar items={dashboardItems} />
      }
    >
      <Outlet />
    </DashboardLayout>
  );
};

export { DashboardDirector };
